import SliceNames from '@/state/enum';
import {
	SecondaryNavActions,
	SecondaryNavState,
} from '@/state/slices/secondary-nav/typings';
import { IStore, SetState } from '@/state/slices/typings';

const secondaryNavActionsCreator = (
	set: SetState<IStore>,
): SecondaryNavActions => {
	return {
		[SliceNames.SECONDARY_NAV]: {
			setBreadcrumbIndex: (
				breadcrumbIndex: SecondaryNavState[SliceNames.SECONDARY_NAV]['breadcrumbIndex'],
			) => {
				set(
					(state) => ({
						...state,
						[SliceNames.SECONDARY_NAV]: {
							...state[SliceNames.SECONDARY_NAV],
							breadcrumbIndex,
						},
					}),
					undefined,
					{
						type: `${SliceNames.SECONDARY_NAV}/setBreadcrumbIndex`,
						breadcrumbIndex,
					},
				);
			},
		},
	};
};

export default secondaryNavActionsCreator;
